import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Empty, PageHeader } from "antd";

import Resources from "scripts/resources";

const EmptyPage = (props) => {
  const { pathname } = useLocation();

  const componentDidUpdate = () => {};

  useEffect(componentDidUpdate, [pathname]);

  return (
    <>
      <PageHeader title={Resources.comingSoon} />
      <Empty />
    </>
  );
};

export default connect(null, (dispatch) => {
  return {
    //onSetRoute: (data) => dispatch(setRoute(data)),
  };
})(EmptyPage);
